import { VisitHistoryEdm } from '@dreryk/egabinet-visit-frontend-api';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../../translations';

import {
   useElectronicDocumentsColumnsConfiguration,
   useElectronicDocumentsDataConfiguration,
} from './electronicDocumentsTable.hooks';

type ElectronicDocumentsTableProps = {
   readonly visitId: number;
};

export const ElectronicDocumentsTable = (props: ElectronicDocumentsTableProps): JSX.Element => {
   return (
      <Table<VisitHistoryEdm>
         testId={'electronicDocuments'}
         dataConfiguration={useElectronicDocumentsDataConfiguration(props.visitId)}
         columns={useElectronicDocumentsColumnsConfiguration()}
         keyExtractor={'externalId'}
         pageSize={1000}
         placeholder={
            <EmptyStatePlaceholder
               testId={'noElectronicDocuments'}
               heading={visitHistoryTranslationKeys.electronicDocumentsTable.noElectronicDocuments}
               subheading={visitHistoryTranslationKeys.electronicDocumentsTable.noElectronicDocumentsIssued}
            />
         }
      />
   );
};
